import { render, staticRenderFns } from "./Template2.vue?vue&type=template&id=61089d52&scoped=true"
import script from "./Template2.vue?vue&type=script&lang=js"
export * from "./Template2.vue?vue&type=script&lang=js"
import style0 from "./Template2.vue?vue&type=style&index=0&id=61089d52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61089d52",
  null
  
)

export default component.exports